import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getUserSelector } from '../../../../../../redux/reducers/reducerSlices/UserReducer';
import { AppConstant } from '../../../../../Assests/AppConstant';
import { sagaActions } from '../../../../../../sagas/sagaActions';
import { initiateSearch, showAlert, changeFormatWithoutTz } from '../../../../../Assests/Utility';
import { getPoSSselector } from '../../../../../../redux/reducers/reducerSlices/POSmartSchedulerReducer';
import EditIcon from '../../../../../Assests/Images/edit-icon-new.png';
import EnabledIcon from '../../../../../Assests/Images/enablePO.png';
import ClockIcon from '../../../../../Assests/Images/clock_icon_past.png';
import DisabledIcon from '../../../../../Assests/Images/disablePO.png';
import DisabledPOIcon from '../../../../../Assests/Images/disabledPO.png';
import CustomTooltip from '../../../../Common/Tooltip/CustomTooltip';
import { fetchPoListCommonFunc } from '../Common/FetchPOList';
import { getCurrentDate } from '../../../../../../Utils/DateUtils';
import { toast } from 'react-toastify';
import moment from 'moment-timezone';
import CompleteIcon from '../../../../../Assests/Images/completed.png'
import ScheduleIcon from '../../../../../Assests/Images/schedule.png'
import RescheduleIcon from '../../../../../Assests/Images/reschedule.png'
import DeletedIcon from '../../../../../Assests/Images/deleted.png'
import WarningIcon from '../../../../../Assests/Images/warning-icon.png'
import _ from 'lodash-es';
import './SsPOList.css';
import DrilldownTableSS from '../../../Components/Dashboard/DefaultDashboard/DrillDownReports/Common/DrilldownTableSS';
import { CustomPaginationSS } from '../../../../Common/CustomPaginationSS/CustomPaginationSS';
import { getRemoteConfigSelector } from '../../../../../../redux/reducers/reducerSlices/RemoteConfigReducer';
import { useNavigate } from 'react-router-dom';
import { smartScheduleSelector } from '../../../../../../redux/reducers/reducerSlices/SmartScheduleReducer';
import CustomButtonSS from '../../../../Common/CustomButton/CustomButtonSS';
import SSPopup from '../../../../Common/Popup/SSPopup/SSPopup';
import PoDetailsPopup from '../../../../Common/PoDetailsPopup/PoDetailsPopup';
import ApptCompletionPopup from '../../../../Common/ApptCompletionPopup/ApptCompletionPopup';
import CommonToggleSwitch from '../../../../Common/CommonToggleSwitch/CommonToggleSwitch';


const SsPOListSS = (props) => {

    const { themeSelected, editPOAction, searchStr, filterSelected, noShowStatus, setSelectedDataObj, setShowEmailModal } = props;
    const dispatch = useDispatch();
    const user = useSelector(getUserSelector);
    const [poArr, setPoArr] = useState([]);
    const { selectedWarehouse, cu_id } = user;
    const [isListLoading, setListLoading] = useState(false);
    const [currentItemIndex, setCurrentItemIndex] = useState('NA');
    const pOSS = useSelector(getPoSSselector);
    const { operationObj, arrangeOrder, arrangeKey, poSSResponse, isLoading } = pOSS;
    const remoteConfig = useSelector(getRemoteConfigSelector);
    const { allConfigration } = remoteConfig;
    const { PaginationDefaultLimit } = allConfigration
    const navigate = useNavigate();
    const ss = useSelector(smartScheduleSelector);
    const { initateLoading, completeManualAppointmentResponse } = ss;
    const [selectedObj, setSelectedObj] = useState(null)
    const [showDeleteModel, setShowDeleteModel] = useState(false);
    const [showPoDetailsModal, setShowPoDetailsModal] = useState(false)
    const [selectedPo, setSelectedPo] = useState(null);
    const [showManualCompletion, setShowManualCompletion] = useState(false)
    const [currentPage, setCurrentPage] = useState(1)
    const [currentLimit, setCurrentLimit] = useState(PaginationDefaultLimit)


    const createPoTitleDD = [
        { id: 'PoNumber', name: AppConstant.poManagement.poDetails.poSoTitle },
        { id: 'LoadType', name: AppConstant.poManagement.tableHeader.loadType },
        { id: 'DockName', name: AppConstant.smartScheduler.poSection.produceType },
        { id: 'Pallets', name: AppConstant.smartScheduler.poSection.palletsCount },
        { id: 'ItemsCases', name: AppConstant.smartScheduler.poSection.cases },
        { id: 'CarrierName', name: AppConstant.poManagement.tableHeader.carrier },
        { id: 'ApptStartTime', name: AppConstant.superUserAdmin.companyGroup.tableHeader.apptTime },
        { id: 'DueDate', name: AppConstant.smartScheduler.poSection.dueDate },
        // { id: 'UpdatedDate', name: AppConstant.commonStrings.updatedOn },
        { id: 'PoCreatedOn', name: AppConstant.superUserAdmin.companyGroup.tableHeader.createdOn },
        { id: 'ApptScheStatus', name: AppConstant.helpSupportFaq.tableHeaders.statusTitle },
        { id: '', name: AppConstant.superUserAdmin.companyGroup.tableHeader.actions },
    ]


    useEffect(() => {
        if (completeManualAppointmentResponse) {
            fetchPoList(searchStr, currentPage, currentLimit)
        }
        return (() => {
            dispatch({ type: sagaActions.CLEAR_COMPLETE_MANUAL_APPOINTMENT_RESPONSE })
        })
    }, [completeManualAppointmentResponse])

    useEffect(() => {
        if (operationObj.type) {
            switch (operationObj.type) {
                case 'Update status':
                    if (operationObj.status) {
                        handleApiResponse(AppConstant.notifications.dataAddedSuccess, AppConstant.smartScheduler.poSection.updatePoStatusSuccess);
                    } else {
                        handleApiResponse(AppConstant.commonStrings.failure, AppConstant.smartScheduler.poSection.updatePoStatusFailure + `: ${operationObj.message}`);
                    }
                    break;
                case 'Fetch POs':
                    if (!operationObj.status) {
                        setListLoading(false);
                    }
                    break
                case 'Delete PO':
                    if (operationObj.status) {
                        handleApiResponse(AppConstant.notifications.dataAddedSuccess, AppConstant.smartScheduler.poSection.deletePOSuccess);
                    } else {
                        handleApiResponse(AppConstant.commonStrings.failure, AppConstant.smartScheduler.poSection.deletePOFailure + `: ${operationObj.message}`);
                    }
                    break;
                default:
            }
        }
    }, [operationObj])

    const handleApiResponse = (result, message) => {
        if (result === AppConstant.notifications.dataAddedSuccess) {
            showAlert(toast.TYPE.SUCCESS, message, themeSelected);
            fetchPoList()
        } else {
            showAlert(toast.TYPE.ERROR, message, themeSelected);
        }
        dispatch({ type: sagaActions.RESET_SS_PO_OPERATION_OBJ });
    }

    useEffect(() => {

        setPoArr([]);
        if (poSSResponse && poSSResponse?.data?.length) {
            setListLoading(false);
            setCurrentItemIndex('NA')
            const poTempArr = poSSResponse.data.map((ele) => {
                if (!ele.CarrierName && ele.ApptScheStatus === 'Not Scheduled') {
                    const tempObj = { ...ele, "CarrierName": "-" };
                    return tempObj
                }
                return ele;
            })
            setPoArr(poTempArr);
        } else {
            if (!operationObj.status) {
                setListLoading(false);
            }
        }
    }, [poSSResponse])


    useEffect(() => {
        let tout;
        if (searchStr && searchStr.length > 3) {
            //const searchedArr = initiateSearch(poSSResponse.data, searchStr, '');
            tout = setTimeout(() => {
                fetchPoList(searchStr)
            }, [1000])
            //setPoArr(searchedArr);
        } else if (searchStr === '') {
            fetchPoList(null)
        }
        return (() => clearTimeout(tout))
    }, [searchStr])

    useEffect(() => {
        dispatch({ type: sagaActions.RESET_PO_LIST });
        setPoArr([]);

    }, [])

    useEffect(() => {
        setListLoading(true);
        let tout;
        if (filterSelected) {
            tout = setTimeout(() => {

                fetchPoList();
            }, [1000])
        }

        return (() => clearTimeout(tout))

    }, [filterSelected])

    useEffect(() => {
        setListLoading(true);
        let tout;
        tout = setTimeout(() => {
            fetchPoList();
        }, [1000])

        return (() => clearTimeout(tout))

    }, [noShowStatus])

    const fetchPoList = (searchParams = null, pageNo = 1, limit = PaginationDefaultLimit,) => {
        const { apiParams, operationObj } = fetchPoListCommonFunc(selectedWarehouse, pageNo, limit, searchParams, filterSelected, noShowStatus);
        dispatch({ type: sagaActions.UPDATE_PO_LIST, payload: apiParams, operationObj: operationObj });
    }

    const deletePOAction = (obj, index) => {
        setCurrentItemIndex(index)
        let tempObj = {
            "PoNumber": obj.PoNumber,
            "CRUDTYPE": "D",
            "IDPO": obj.IDPO,
            "PoStatus": !obj.PoStatus,
            "CreatedOn": obj.PoCreatedOn,
            "CreatedBy": cu_id,
            "UpdatedOn": changeFormatWithoutTz(getCurrentDate(), AppConstant.commonStrings.YYYY_MM_DD_T_HH_mm_ss),
            "UpdatedBy": cu_id
        }
        const operationObj = {
            type: 'Update status',
            status: ''
        }
        setListLoading(true);
        const response = _.find(poArr, { 'PoNumber': obj.PoNumber });
        let tempObjRes = { ...response }
        if (!_.isEmpty(tempObjRes)) {
            let tempArr = JSON.parse(JSON.stringify(poArr));
            tempObj.PoStatus = !tempArr[index].PoStatus;
            tempArr[index] = tempObj;
            setPoArr(tempArr)
            dispatch({ type: sagaActions.UPDATE_PO_LIST, payload: { ...obj, ...tempObj }, operationObj: operationObj })
        }
    }  

    const editPO = (el, index) => {
        editPOAction(el, index);
    }
    /**
         * delete popup handler to delete the records based on the confirmation
         * @param {*} text 
         */
    const popupBtnHandler = (text) => {
        if (text === AppConstant.commonStrings.no) {
            setShowDeleteModel(false)
            setSelectedObj(null)
            // setSelectedIndex(null)
        }
        else {
            let apiParams = {
                "PoNumber": selectedObj.PoNumber,
                "CRUDTYPE": "R",
                "IDPO": selectedObj.IDPO,
                // "PoStatus": !selectedObj.PoStatus,
                "CreatedOn": selectedObj.PoCreatedOn,
                "CreatedBy": cu_id,
                "UpdatedOn": changeFormatWithoutTz(getCurrentDate(), AppConstant.commonStrings.YYYY_MM_DD_T_HH_mm_ss),
                "UpdatedBy": cu_id,
                "WarehouseId": selectedObj.IDWarehouse,
                "PoStatus": null,
                "LoadType": null
            }

            const operationObj = {
                type: 'Delete PO',
                status: ''
            }
            setListLoading(true);
            dispatch({ type: sagaActions.UPDATE_PO_LIST, payload: apiParams, operationObj: operationObj })
        }
        setShowDeleteModel(false)
    }
    /**
     * Helper to show the delete conformation pop-up
     * @returns 
     */
    const showDeleteConfirmation = () => {
        const popupObj = {
            id: 'showDeleteConfirmation',
            modalLabel: 'showDeleteConfirmation',
            showClose: true,
            showfooter: true,
            showHeader: true,
            sendDriverNotification: false,
            modalSize: 'md',
            title: AppConstant.poManagement.PO.poDelete,
            bodyText: `${AppConstant.commonStrings.areYouSure} ${AppConstant.poManagement.PO.poDelete} ${selectedObj?.PoNumber}`,
            subText: "",
            keyboard: false,
            backdrop: "static",
            footerBtn: {
                btn1: {
                    show: true,
                    text: AppConstant.commonStrings.yes
                },
                btn2: {
                    show: true,
                    text: AppConstant.commonStrings.no
                }
            },
        }

        return <SSPopup {...popupObj} popupBtnHandler={(text) => { popupBtnHandler(text) }} closepopup={() => { setShowDeleteModel(false) }} themeSelected={themeSelected} showModal={showDeleteModel} />
    }

    /**
     * Helper to delete
     * @param {*} data 
     * @param {*} index 
     */
    const deleteHandler = (data, index) => {
        if (data.ApptScheStatus === 'Not Scheduled' || data.ApptScheStatus === 'Date Expired') {
            setSelectedObj(data, index)
            // setSelectedIndex(index)
            setShowDeleteModel(true)
        } else {
            return
        }
    }

    const actionButtons = (el, index) => {
        const dueDate = moment(el.DueDate).utc().endOf('day');
        const todayDate = moment().utc().startOf('day')
        dueDate.add(1, 'days');
        return (
            // <div className='d-flex justify-content-center my-2'>
            <div className='d-flex flex-column'>

                <span className='d-flex justify-content-center align-items-center gap-2' >

            
                    {/* {el.ApptScheStatus === "Not Scheduled"?<button
                 className=' no-bg no-border'
                 onClick={()=>{
                    setSelectedDataObj(el)
                    setShowEmailModal(true)
                    }}>
                <i className="fa-regular fa-envelope fa-lg"></i>
                </button>:''} */}
                    <img src={EditIcon}
                        // className={`editIconPO-ss $${el.ApptScheStatus === 'Not Scheduled' ||  el.ApptScheStatus === 'Date Expired' && todayDate.isBefore(dueDate)? '' : 'disabled edit-disable'}`}
                        className={`editIconPO-ss`}
                        alt="Edit Order"
                        // data-tip={el.ApptScheStatus === 'Not Scheduled' || el.ApptScheStatus === 'Date Expired' && todayDate.isBefore(dueDate) ? 'Edit Order' : ''}
                        data-tip={'Edit Order'}
                        data-for={'tooltip_id'}
                        // onClick={el.ApptScheStatus === 'Not Scheduled' || el.ApptScheStatus === 'Date Expired' && todayDate.isBefore(dueDate) ? () => editPO(el, index) : () => ''}
                        onClick={() => editPO(el, index)}

                    />
                    {/* <img
                        src={el.ApptScheStatus !== 'Not Scheduled' ?
                            DisabledPOIcon : el.PoStatus ? EnabledIcon : DisabledIcon}
                        data-tip={el.ApptScheStatus !== 'Not Scheduled' ? '' : el.PoStatus ? 'Enabled' : 'Disabled'}
                        data-for={'tooltip_id'}
                        className={`editIconPO-ss ${el.ApptScheStatus === 'Not Scheduled' ?
                            '' : 'disabled'}`} alt="Change Status"
                        onClick={el.ApptScheStatus === 'Not Scheduled' ? () => deletePOAction(el, index) : () => ''} /> */}
                    <span data-tip={el.ApptScheStatus !== 'Not Scheduled' ? '' : el.PoStatus ? 'Enabled' : 'Disabled'} data-for={'tooltip_id'}
                    className={`editIconPO-ss ${el.ApptScheStatus === 'Not Scheduled' ? '' : 'disabled'}`} alt="Change Status">
                      <CommonToggleSwitch value={el.PoStatus}
                    onChangeValue={el.ApptScheStatus === 'Not Scheduled' ? () => deletePOAction(el, index) : () => ''} allowPermissionD={true}/>
                    </span>

                    <CustomButtonSS
                        disabled={el.ApptScheStatus === 'Not Scheduled' || el.ApptScheStatus === 'Date Expired' ? false : true}
                        className={el.ApptScheStatus === 'Not Scheduled' || el.ApptScheStatus === 'Date Expired' ? `no-border no-bg` : `no-border no-bg disabled`}
                        onClick={() => { deleteHandler(el, index) }}
                        isIcon={true}
                        iconClass={"fa-regular fa-trash-can fa-lg"}
                    />
                    <CustomTooltip
                        id={'tooltip_id'}
                        position='top'
                        type={themeSelected === AppConstant.commonStrings.lightModeFilterString ? 'light' : 'dark'}
                        multiline={false} />
                    <CustomTooltip
                        id={'complition_id'}
                        position='top'
                        type={themeSelected === AppConstant.commonStrings.lightModeFilterString ? 'light' : 'dark'}
                        multiline={false} />
                </span>
                <span className='d-flex justify-content-center align-items-center gap-2'>
                {<button
                        className={el.ApptScheStatus === "Not Scheduled" ? 'no-bg no-border' : 'no-bg no-border edit-disable'}
                        onClick={() => {
                            if (el.ApptScheStatus === "Not Scheduled") {
                                setSelectedDataObj(el)
                                setShowEmailModal(true)
                            } else {
                                showAlert(toast.TYPE.ERROR, AppConstant.poManagement.poTooltip.email)
                            }
                        }}>
                        <i className="fa-regular fa-envelope fa-lg"></i>
                    </button>
                    }
                <span onClick={() => {
                        setSelectedPo(el)
                        setShowPoDetailsModal(true)
                    }}><i className="fa-solid fa-circle-info text-grey fa-lg" title='Show More Details'></i></span>
                    <img
                        src={el.ApptScheStatus === 'Completed' ? ClockIcon : DisabledIcon}
                        data-tip={el.ApptScheStatus === 'Completed' ? 'Edit Completed Time': 'Mark as complete'}
                        data-for={'tooltip_id_1'}
                        className={`editIconPO-ss ${el && el.DockAppointmentCompletionConfig && el.DockAppointmentCompletionConfig.toUpperCase() === "MANUAL" && (el.ApptScheStatus === "Re-scheduled" || el.ApptScheStatus === "Scheduled" || el.ApptScheStatus === "Completed") ?
                            '' : 'disabled'}`} alt="Change Status"
                        onClick={() => {
                            if (el && el.DockAppointmentCompletionConfig && el.DockAppointmentCompletionConfig.toUpperCase() === "MANUAL" && (el.ApptScheStatus === "Re-scheduled" || el.ApptScheStatus === "Scheduled" || el.ApptScheStatus === "Completed")) {     
                                setSelectedObj(el)
                                setShowManualCompletion(true)
                            }
                            else {
                                return
                            }
                        }} />
                    {/* <span data-tip={'Mark Complete'}
                        data-for={'tooltip_id_1'}>
                        <CustomButtonSS
                            disabled={el && el.DockAppointmentCompletionConfig && el.DockAppointmentCompletionConfig.toUpperCase() === "MANUAL" && (el.ApptScheStatus === "Re-scheduled" || el.ApptScheStatus === "Scheduled") ? false: true}
                            isLoading={false}
                            // title='Mark as Complete'
                            className={el && el.DockAppointmentCompletionConfig && el.DockAppointmentCompletionConfig.toUpperCase() === "MANUAL" && (el.ApptScheStatus === "Re-scheduled" || el.ApptScheStatus === "Scheduled") ? 'no-bg no-border': 'no-bg no-border edit-disable'}
                            onClick={() => {
                                if (el && el.DockAppointmentCompletionConfig && el.DockAppointmentCompletionConfig.toUpperCase() === "MANUAL" && (el.ApptScheStatus === "Re-scheduled" || el.ApptScheStatus === "Scheduled")) {     
                                    setSelectedObj(el)
                                    setShowManualCompletion(true)
                                }
                                else {
                                    return
                                }
                            }}
                        isIcon={true}
                        iconClass={'fa-solid fa-circle-check fa-lg'}
                        />
                        </span> */}
                     <CustomTooltip
                        id={'tooltip_id_1'}
                        position='top'
                        type={themeSelected === AppConstant.commonStrings.lightModeFilterString ? 'light' : 'dark'}
                        multiline={false} />
                    
                </span>
            </div>
        )
    }

    /**
     * Function to show alert on click of date expired
     */
    const showDateExpiredAlert = () => {
        showAlert(toast.TYPE.WARNING, AppConstant.poManagement.dateExpired)
    }

    /**
     * Function to render appointment status
     * @param {*} el 
     * @returns 
     */
    const getApptSchStatusColor = (el) => {
        const dueDate = moment(el.DueDate).utc().startOf('day');
        const todayDate = moment().utc().startOf('day')

        if (el.ApptScheStatus === 'Completed') {
            return <div className='appt-status-block-ss disabled'><img src={CompleteIcon} alt=' ' /> {el.ApptScheStatus}</div>
        } 
        else if (el.ApptScheStatus === 'In Progress') {
            return <div className='appt-status-block-ss disabled'><img src={ScheduleIcon} alt=' ' /> {el.ApptScheStatus}</div>
        }
        else if ((el.ApptScheStatus === 'Re-scheduled' || el.ApptScheStatus === 'Rescheduled' ) && el.Rescheduled) {
            return <div className={`${!el.PoStatus && 'disabled'} appt-status-block-ss`} onClick={() => goToSchedulerPage(el)}><img src={RescheduleIcon} alt=' ' /> {'Rescheduled'}</div>
        }
        else if (el.ApptScheStatus === 'Scheduled') {
            return <div className={`${!el.PoStatus && 'disabled'} appt-status-block-ss`} onClick={() => goToSchedulerPage(el)}><img src={ScheduleIcon} alt=' ' /> {el.ApptScheStatus}</div>
        }
        else if (el.ApptScheStatus === 'Date Expired') {
            return <div className={`${!el.PoStatus && 'disabled'} appt-status-block-ss`} onClick={showDateExpiredAlert}><img src={WarningIcon} alt=' ' height={15} width={15} /> {AppConstant.poManagement.statusFilters.dateExpired}</div>
        }
        //    else if (new Date(moment(el.DueDate).utc().format(AppConstant.commonStrings.MM_DD_YYYY__HH_mm_ss)).getTime() < new Date().getTime()) {
        //       el.PoNumber === '70001' && console.log('----------', moment(el.DueDate),  moment())
        //         return <div className={`${!el.PoStatus && 'disabled'} appt-status-block-ss`} onClick={showDateExpiredAlert}><img src={WarningIcon} alt=' ' height={15} width={15}/> { AppConstant.poManagement.statusFilters.dateExpired}</div>
        //     }
        else {
            return <div className={`${!el.PoStatus && 'disabled'} appt-status-block-ss`} onClick={() => goToSchedulerPage(el)}><img src={DeletedIcon} alt=' ' /> {el.ApptScheStatus}</div>
        }
    }

    const getLoadType = (el) => {
        if (el?.LoadType && el?.ExternalLoadType) {
            return `${el?.ExternalLoadType?.toUpperCase()}/${el.LoadType}`
        }else if (el?.LoadType && !el?.ExternalLoadType) {
            return `${el.LoadType}`
        }
        else if (!el?.LoadType && el?.ExternalLoadType) {
            return `${el?.ExternalLoadType?.toUpperCase()}`
        } else {
            return '-'
        }
         
    }

    const formatListDataDrillDown = (data) => {
        return data.map((el, index) => {
            return {
                id: el.RoleID,
                // 0: ((poSSResponse.pageNo-1)*poSSResponse.limit+(index + 1)),
                0: (
                    <div className="po-number-container">
                        {el.NoShowStatus && (
                            <>
                                <span
                                    className="no-show-badge"
                                    data-tip="No Show"
                                    data-for={'no_show_tooltip'}
                                >
                                    NS
                                </span>
                                <CustomTooltip
                                    id={'no_show_tooltip'}
                                    position='top'
                                    type={themeSelected === AppConstant.commonStrings.lightModeFilterString ? 'light' : 'dark'}
                                    multiline={false}
                                />
                            </>
                        )}
                        <span>{el.PoNumber || '-'}</span>
                    </div>
                ),
                1: getLoadType(el),
                2: el.DockName || '-',
                3: el.Pallets || '-',
                4: el.ItemsCases || '-',
                5: el.CarrierName,
                6: el?.ApptStartTime ? `${moment(el.ApptStartTime).utc().format(AppConstant.commonStrings.MM_DD_YYYY_dateFormat)}\n${moment(el.ApptStartTime).utc().format(AppConstant.commonStrings.HH_mm_dateFormat)}` || '-' : '-',
                7: el.DueDate ? moment(el.DueDate).utc().format(AppConstant.commonStrings.MM_DD_YYYY_dateFormat) : '-',
                8: `${moment(el.PoCreatedOn).utc().format(AppConstant.commonStrings.MM_DD_YYYY_dateFormat)}` || '-',
                9: el.ApptScheStatus ? getApptSchStatusColor(el) : '-',
                10: actionButtons(el, index)
            }
        })
    }

    const getPaginationArr = () => {
        return [1, 2, 3, 4, 5].map((item, index) => {
            return <li className="page-item"><a className="page-link text-dark" href="#">{item}</a></li>
        })
    }
    const pageChange = (pageNo, limit = Number(PaginationDefaultLimit)) => {
        setCurrentPage(pageNo)
        setCurrentLimit(limit)
        fetchPoList(searchStr, pageNo, limit)
    }

    /**
     * Function to update po data for sechedule/reschedule and navigate to book appointment page
     * @param {*} rowData 
     */
    const goToSchedulerPage = (rowData) => {
        if (rowData.PoStatus) {
            dispatch({ type: sagaActions.INTIATE_SS_SEARCH_PO, payload: { PoNumber: rowData?.PoNumber, ReceivingZipCode: rowData?.ReceivingZipCode, UserType: 'USER', ID: rowData?.IDWarehouse } })
            dispatch({ type: sagaActions.UPDATE_SS_SEARCH_PO, payload: [rowData] })
            setTimeout(() => {
                navigate('/bookappointments');
            }, [500])

            //     if (searchedPOData) {
            //         navigate('/bookappointments');
            //         dispatch({ type: sagaActions.UPDATE_SS_SEARCH_PO, payload: [rowData] })
            // }else{
            //     showAlert(toast.TYPE.ERROR, AppConstant.notifications.login.wentWrong)
            // }
        }
    }


    return (
        <div className=''>
            {
                <div className='mt-3 appointmentListTable'>
                    <DrilldownTableSS
                        themeSelected={themeSelected}
                        bodyData={poArr && poArr.length ? formatListDataDrillDown(poArr) : []}
                        titleData={createPoTitleDD}
                        showCollapse={false}
                        showInput={false}
                        showSort={true}
                        sortKey={true}
                        arrangeOrder={arrangeOrder}
                        arrangeKey={arrangeKey}
                        drillDownReport={poArr}
                        initiateDrillDownReport={isLoading}
                        loaderArray={12}
                        sortingAction={sagaActions.SORT_SS_USER_TABLE}
                        subRoot={{ pathName: 'poSSResponse' }}
                        showUTCTime={true}
                        isPaginated={true}
                    />

                    {showDeleteConfirmation()}


                    {/* PAGINATION UI COMPONENT <div className='sticky-bottom mt-auto justify-content-end pb-3 bg-transparent'>
                        <nav className='mx-5 paginationSection bg-transparent'>
                            <ul className="pagination justify-content-end w-100 bg-transparent">
                                <li className="page-item bg-transparent">
                                    <a className="page-link text-dark" href="#">
                                        <span aria-hidden="true">&laquo;</span>
                                    </a>
                                </li>
                                {getPaginationArr()}
                                <li className="page-item">
                                    <a className="page-link text-dark" href="#">
                                        <span aria-hidden="true">&raquo;</span>
                                    </a>
                                </li>
                            </ul>
                        </nav>
                    </div> */}
                </div>
            }
            {poSSResponse && poSSResponse.data && poSSResponse.data.length ?
                <CustomPaginationSS
                    pageChange={(pageNo, limit) => { pageChange(pageNo, limit) }}
                    pageNo={poSSResponse.pageNo}
                    pageSize={poSSResponse.limit}
                    totalElements={poSSResponse.totalElements}
                    totalPages={Math.ceil(poSSResponse.totalElements / poSSResponse.limit)}
                    last={poSSResponse.last}
                    first={poSSResponse.first}
                    data={poSSResponse.data}
                    isLoading={isLoading}
                /> : ""
            }
            {showPoDetailsModal ? <PoDetailsPopup showModal={showPoDetailsModal} setCloseModal={setShowPoDetailsModal} poData={{ ...selectedPo, WarehouseData: { Name: selectedPo.WarehouseName } }} initateLoading={false} /> : ''}
            {showManualCompletion ? <ApptCompletionPopup showModal={showManualCompletion} poDetails={selectedObj} setCloseModal={setShowManualCompletion} initateLoading={initateLoading} maxDate={selectedObj.DueDate} minDate={selectedObj.ApptEndTime} editData={selectedObj} setEditData={setSelectedObj} /> : ''}


        </div>
    )

}
export default SsPOListSS;